import React from 'react';

export const StaffPickIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32">
      <g>
        <g id="staffpicks_layer_1">
          <g>
            <circle cx="16" cy="16" r="16" />
            <g>
              <path
                className="path-1"
                d="M20.47,9.32h-3.81v13.35h1.91v-5.72h1.91c1.05,0,1.91-.85,1.91-1.91v-3.81c0-1.05-.85-1.91-1.91-1.91ZM18.57,15.05h1.91v-3.81h-1.91v3.81Z"
              />
              <path
                className="path-1"
                d="M15.39,13.14v-1.91c0-1.05-.85-1.91-1.91-1.91h-1.91c-1.05,0-1.91.85-1.91,1.91v3.81c0,1.05.85,1.91,1.91,1.91h1.91v3.81h-1.91v-1.91h-1.91v1.91c0,1.05.85,1.91,1.91,1.91h1.91c1.05,0,1.91-.85,1.91-1.91v-3.81c0-1.05-.85-1.91-1.91-1.91h-1.91v-3.81h1.91v1.91h1.91Z"
              />
            </g>
            <g>
              <path
                className="path-2"
                d="M5.18,14.92c-.49.37-.94.8-1.38,1.28-.45-.46-.88-.98-1.27-1.54.1-1.04.32-2.06.66-3.05.25.64.54,1.24.88,1.79.53-.37,1.08-.67,1.64-.93-.27.79-.45,1.61-.53,2.45Z"
              />
              <path
                className="path-2"
                d="M5.4,18.42c-.35.51-.65,1.06-.91,1.65-.58-.29-1.15-.65-1.69-1.06-.23-1.02-.34-2.06-.34-3.1.45.52.91,1,1.41,1.42.39-.51.82-.98,1.26-1.4,0,.84.09,1.68.27,2.49Z"
              />
              <path
                className="path-2"
                d="M6.72,21.66c-.16.59-.27,1.21-.33,1.85-.64-.09-1.29-.25-1.94-.46-.55-.89-.99-1.84-1.32-2.83.59.36,1.18.65,1.79.89.21-.61.46-1.19.75-1.73.26.79.62,1.56,1.06,2.27Z"
              />
              <path
                className="path-2"
                d="M9,24.32c.04.61.13,1.23.27,1.87-.63.11-1.3.17-1.99.17-.8-.67-1.52-1.43-2.14-2.27.67.15,1.33.24,1.97.28,0-.65.05-1.27.16-1.88.5.67,1.08,1.29,1.72,1.83Z"
              />
              <path
                className="path-2"
                d="M6.08,11.54c-.58.2-1.15.46-1.72.77-.28-.58-.52-1.21-.71-1.86.43-.95.97-1.85,1.6-2.68.03.68.12,1.34.26,1.98.62-.18,1.24-.3,1.85-.35-.51.66-.94,1.39-1.29,2.15Z"
              />
              <path
                className="path-1"
                d="M7.02,6.59c-.37.73-.67,1.47-.88,2.21.64-.43,1.32-.77,1.98-1.05.31-.66.69-1.3,1.15-1.93-.75.19-1.5.44-2.25.78Z"
              />
            </g>
            <g>
              <path
                className="path-2"
                d="M29.47,14.66c-.38.56-.82,1.08-1.27,1.54-.44-.48-.89-.9-1.38-1.28-.08-.83-.26-1.66-.53-2.45.55.25,1.11.56,1.64.93.34-.55.63-1.15.88-1.79.34.99.56,2.01.66,3.05Z"
              />
              <path
                className="path-2"
                d="M29.2,19.01c-.54.41-1.11.76-1.69,1.06-.26-.59-.56-1.14-.91-1.65.19-.82.28-1.65.27-2.49.44.42.87.88,1.26,1.4.5-.42.96-.89,1.41-1.42,0,1.04-.11,2.08-.34,3.1Z"
              />
              <path
                className="path-2"
                d="M27.55,23.05c-.65.21-1.3.37-1.94.46-.06-.64-.17-1.26-.33-1.85.44-.71.79-1.48,1.06-2.27.28.53.54,1.11.75,1.73.6-.24,1.19-.54,1.79-.89-.33.99-.77,1.94-1.32,2.83Z"
              />
              <path
                className="path-2"
                d="M24.71,26.36c-.69,0-1.35-.07-1.99-.17.14-.64.23-1.26.27-1.87.64-.54,1.22-1.15,1.72-1.83.11.6.16,1.23.16,1.88.64-.04,1.31-.13,1.97-.28-.62.84-1.34,1.6-2.14,2.27Z"
              />
              <path
                className="path-2"
                d="M28.35,10.45c-.19.66-.43,1.28-.71,1.86-.57-.31-1.14-.57-1.72-.77-.34-.76-.78-1.49-1.29-2.15.61.06,1.23.18,1.85.35.14-.63.23-1.3.26-1.98.63.83,1.17,1.73,1.6,2.68Z"
              />
              <path
                className="path-1"
                d="M23.87,7.75c.67.28,1.34.63,1.98,1.05-.21-.74-.51-1.48-.88-2.21-.75-.34-1.5-.59-2.25-.78.45.63.84,1.28,1.15,1.93Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
